import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import dayjs from 'dayjs';
import type { GetConditionMeetVariables } from './types';
import { checkInvalidDate } from '../../ApplicationForm';
import type { Condition } from '../../../../Assessment/graphql';
import { getMeetConditionStatus } from '../../../components/ApplicationStatus/Offer/ConditionMeet/meetConditionFunctions';
import { type MeetingConditionStatus } from '../../Offer';

const GET_APPLICANT_CONDITION_MEET = gql`
  query ($applicationId: String!) {
    meetCondition(applicationId: $applicationId) {
      status
      updatedAt
      conditionFulfillingDeadline
      contactDepartmentPersonName
      contactDepartmentPersonEmail
      conditions {
        item
        passed
        remark
        file {
          id
          name
          link
        }
        title
        detail
      }
    }
  }
`;

export const useGetApplicantConditionMeet = (
  applicationId: string,
): GetConditionMeetVariables => {
  const { data, loading, error, refetch } = useQuery(
    GET_APPLICANT_CONDITION_MEET,
    {
      variables: { applicationId },
      skip: !applicationId,
      fetchPolicy: 'network-only',
    },
  );

  const {
    conditions = [],
    status,
    updatedAt,
    conditionFulfillingDeadline,
  } = data?.meetCondition ?? {};

  const conditionData =
    conditions?.map((condition: Condition) => {
      const { item, file, passed, remark, checkedBy, title, detail } =
        condition ?? {};

      return {
        item,
        file: file ?? [],
        passed,
        remark: remark ?? '',
        checkedBy,
        title,
        detail,
      };
    }) ?? [];
  const fullStatus = getMeetConditionStatus(
    status as MeetingConditionStatus,
    conditionFulfillingDeadline,
  );

  const contactDepartmentPersonName =
    data?.meetCondition?.contactDepartmentPersonName ?? '';
  const contactDepartmentPersonEmail =
    data?.meetCondition?.contactDepartmentPersonEmail ?? '';

  return {
    conditionMeet: {
      conditions: conditionData,
      status: fullStatus,
      updatedAt: checkInvalidDate(updatedAt)
        ? 'N/A'
        : dayjs(updatedAt).format('DD/MM/YYYY'),
      conditionFulfillingDeadline: checkInvalidDate(conditionFulfillingDeadline)
        ? 'N/A'
        : dayjs(conditionFulfillingDeadline).format('DD/MM/YYYY'),
      contactDepartmentPersonName,
      contactDepartmentPersonEmail,
    },
    loading,
    error,
    refetch,
  };
};
